import React from "react";

const UnauthorizedPage: React.FC = () => (
  <div className="p-8 text-center">
    <h1 className="text-2xl font-bold">Unauthorized</h1>
    <p className="mt-2">You do not have permission to view this page.</p>
  </div>
);

export default UnauthorizedPage;

